import settings from './settings.json';
import sidebar from './sidebar.json';
import common from './common.json';
import button from './button.json';
import error from './error.json';
import breadcrumbs from './breadcrumbs.json';
import brands from './brands.json';
import productTypes from './productTypes.json';
import productCollections from './productCollections.json';
import productCategories from './productCategories.json';
import productAttributes from './productAttributes.json';
import orders from './orders.json';
import sizeGuide from './sizeGuide.json';
import mores from './mores.json';
//TODO: DON'T REMOVE ==> import i18n
import products from './products.json';
import blogs from './blogs.json';
import customers from './customers.json';
import locationStocks from './locationStocks.json';
import communications from './communications.json';
import reviewProducts from './reviewProducts.json';
import input from './input.json';
import promotions from './promotions.json';
import websiteConfigs from './websiteConfigs.json';
import cms from './cms.json';
import miscellaneous from './miscellaneous.json';
import enquiries from './enquiries.json';
import regularQuestions from './regularQuestions.json';
import promotionExternals from './promotionExternals.json';
import users from './users.json';
import bundles from './bundles.json';
import customData from './customData.json';
import transferOrders from './transferOrders.json';
import ordersReturn from './ordersReturn.json';
import chainStores from './chainStores.json';
import inProcessOrders from './inProcessOrders.json';
import ordersExchange from './ordersExchange.json';
import ordersTabTryBuy from './ordersTabTryBuy.json';

export default {
  settings,
  sidebar,
  common,
  button,
  error,
  //TODO: DON'T REMOVE ==> register i18n
  products,
  breadcrumbs,
  brands,
  productTypes,
  productCollections,
  productCategories,
  productAttributes,
  sizeGuide,
  mores,
  blogs,
  customers,
  ...orders,
  locationStocks,
  communications,
  reviewProducts,
  input,
  ...promotions,
  websiteConfigs,
  cms,
  miscellaneous,
  enquiries,
  regularQuestions,
  promotionExternals,
  users,
  bundles,
  customData,
  transferOrders,
  ordersReturn,
  chainStores,
  inProcessOrders,
  ordersExchange,
  ordersTabTryBuy,
};
